import { VisitorsEmailsState } from './types';
import { createAction } from 'typesafe-actions';

export const setVisitors = createAction('SET_VISITORS')<VisitorsEmailsState>();
export const clearVisitors = createAction('CLEAR_VISITORS')<void>();
export const removeVisitor = createAction('REMOVE_VISITOR')<number>();
